export default "https://cdn-static.gokick.com/assets/bae15fb1898ed89c0d72225e63ca082ea63e0d65/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";